import type {AggregationSurveyListItem} from "crqlar-react-common/dist/models/aggregation/surveyAggregation.model";
import {SurveyAggregationService} from "crqlar-react-common/dist/services/aggregation/surveyAggregation.service";
import {useQuery} from "react-query";
import {fetchEveryPage} from "./fetchEveryPage";
import {SURVEY_LIST_QUERY_KEY} from "./surveyQueryRefresh";

export interface AllSurveys {
    surveys: AggregationSurveyListItem[];
    isLoading: boolean;
}

// One array for every render until the list arrives, so memos over it don't run again.
const NO_SURVEYS: AggregationSurveyListItem[] = [];

/**
 * Every survey, newest first as the API sends them: the one list behind the survey pickers and filters. One key, so a
 * screen opened after another shows its picker without a spinner, and one useSurveyChangeRefresh updates them all.
 * Screens derive their subset with a useMemo of their own; a sorted subset sorts a copy, never this cached array.
 */
export function useAllSurveys(): AllSurveys {
    const query = useQuery(
        [SURVEY_LIST_QUERY_KEY],
        () => fetchEveryPage(limit => SurveyAggregationService.listSurveys({limit})),
        {refetchOnWindowFocus: false}
    );

    return {surveys: query.data ?? NO_SURVEYS, isLoading: query.isLoading};
}
